// import Error from 'components/alerts/Error';
import { Text } from 'components/common/form/modules/input/Text';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { isEmailAvailable, isUsernameAvailable, signup } from 'components/graphql/queries'
import { closeModal } from 'components/modal/modules/dispatcher/methods';

import cloneDeep from 'lodash/cloneDeep';

import React, { useCallback, useState } from 'react'

import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { AuthenticationService } from 'services/api/Authentication.service';
import UserDucks from 'stores/ducks/User.duck';


const SignupForm: React.FC<{ [label: string]: any }> = (props: any) => {
    const [username, setUsername] = useState('')
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [lastname, setLastname] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    // const [error, setError] = useState(false)
    // const [errorMessage, setErrorMessage] = useState('')

    const emailIsValid = (e) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
    }

    const createAccount = useCallback(() => {
        // Error checks
        if (name === '' || lastname === '' || username === '' || email === '' || password === '' || confirmPassword === '') {
            alert('Fill out missing information')
            return
        }

        // Check if string contains at least a number
        const regex = /\d/

        if (regex.test(name)) {
            alert('First name is invalid')
            return
        }

        if (regex.test(lastname)) {
            alert('Last name is invalid')
            return
        }

        if (!emailIsValid(email)) {
            alert('Email is invalid')
            return
        }

        if (password.length < 8) {
            alert('Password should be at least 8 charactors in length')
            return
        }

        if (password !== confirmPassword) {
            alert('Passwords don\'t match')
            return
        }

        // Check if username is available
        // Then create user
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: isUsernameAvailable,
                variables: {
                    username: username.toLowerCase()
                }
            })
            .then(res => {
                if (res.data.data.user.isUsernameAvailable) {
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: isEmailAvailable,
                            variables: {
                                email: email.toLowerCase()
                            }
                        })
                        .then(res2 => {
                            if (res2.data.data.user.isEmailAvailable) {
                                fetchAPI
                                    .post(API_ENDPOINTS.BASE_URL, {
                                        query: signup,
                                        variables: {
                                            user: {
                                                name,
                                                email: email.toLowerCase(),
                                                username: username.toLowerCase(),
                                                password,
                                                lastname
                                            }
                                        }
                                    })
                                    .then(res3 => {
                                        if (res3.data.data.user.create) {
                                            const AuthService = new AuthenticationService();
                                            AuthService.authWithPassword(email.toLowerCase(), password)
                                                .catch(ee => {
                                                    window.location.pathname = '/login'
                                                })
                                                .then((res4: any) => {
                                                    if (res4.token === undefined) {
                                                        alert('Unkwown error occurred')
                                                        return
                                                    }
                                                    const newRes = cloneDeep(res4);
                                                    delete newRes.events;

                                                    props.dispatch(UserDucks.setUser(res4));
                                                    // Removing old cookies
                                                    props.cookies.remove("user", { path: "/" });
                                                    props.cookies.remove("token", { path: "/" });
                                                    // Putting new cookies
                                                    const date = new Date(); date.setDate(date.getDate() + 7);
                                                    props.cookies.set("user", newRes, { path: "/", expires: date });
                                                    props.cookies.set("token", res4.token, { path: "/", expires: date });

                                                    window.location.pathname = '/campaigns'
                                                });
                                        } else {
                                            alert('Email already in use.')
                                            return
                                        }
                                    })
                                    .catch(err => {
                                        console.log(err)
                                    })
                            } else {
                                alert('Email already in use.')
                                return
                            }
                        })
                        .catch(err => {
                            console.log(err)
                        })
                } else {
                    alert('Username already in use.')
                    return
                }
            })
            .catch(err => {
                console.log(err)
            })
    }, [name, username, email, password, confirmPassword, lastname, emailIsValid])

    return <div style={{ padding: '20px' }}>
        <Text
            label='Username'
            value={username}
            onChange={e => setUsername((e.target.value).split(' ').join(''))}
        />
        <Text
            label='Email'
            value={email}
            onChange={e => setEmail(e.target.value)}
        />
        <Text
            label='First Name'
            value={name}
            onChange={e => setName(e.target.value)}
        />
        <Text
            label='Last Name'
            value={lastname}
            onChange={e => setLastname(e.target.value)}
        />
        <Text
            label='Password'
            name='password'
            value={password}
            onChange={e => setPassword(e.target.value)}
        />
        <Text
            name='password'
            label='Confirm Password'
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
        />
        {/* {
            error ?
                <Error content={errorMessage} /> : null
        } */}
        <div style={{ width: '100%', paddingTop: '20px', textAlign: 'center' }}>
            <button className='new-button-save' onClick={() => createAccount()}>
                SIGN UP
            </button>
            <p />
        </div>
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '10px' }}>
            <button className='new-button-cancel' onClick={() => closeModal()}>
                CANCEL
            </button>
        </div>
    </div>
}

const mapStateToProps = state => {
    return {
        isLoading: UserDucks.isLoading(state),
        isLoggedIn: UserDucks.isAuthenticated(state)
    };
};

const x = withCookies(SignupForm);
export default connect(mapStateToProps)(x)


// WEBPACK FOOTER //
// ./src/pages/auth/login/components/login-form/Signup.tsx